import {useNProgress} from "@tanem/react-nprogress";
import Container from "./Container";
import Bar from "./Bar";
import React from "react";

const Progress: React.FC<{ isAnimating: boolean }> = ({isAnimating}) => {
    const {animationDuration, isFinished, progress} = useNProgress({
        isAnimating,
    })

    return (
        <Container animationDuration={animationDuration} isFinished={isFinished}>
            <Bar animationDuration={animationDuration} progress={progress}/>
        </Container>
    )
}

export default Progress;